import { render } from "./RegisterApp.vue?vue&type=template&id=6c8acca9"
import script from "./RegisterApp.vue?vue&type=script&lang=js"
export * from "./RegisterApp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__